export function Button({
  children,
  onClick,
  variant = 'primary',
  type = 'button',
  disabled = false,
  ariaLabel,
  testId,
  audioCue,
  changesScreen = false
}) {
  const className = `button button-${variant}`;
  return (
    <button
      type={type}
      className={className}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      data-testid={testId}
      data-audio-cue={audioCue ?? (changesScreen ? 'buttonPrimary' : undefined)}
    >
      {children}
    </button>
  );
}
